export default {
    page_title: "Kevi | Client Base Management",
    title: "Client Base Management",
    last_step_confirm: "This is the last step,",
    last_step_irreversible: "this action is irreversible!",
    start_deletion_text: "To start the partial removal process of your client base,",
    click_here: "click here",
    step1_title: "1. Set Filters for Client Deletion",
    apply_filters: "Apply Filters",
    step2_title: "2. Confirm Clients and Leads to be Deleted",
    step3_title: "3. Confirm and Delete Clients",
    col_name: "Name",
    col_phone: "Phone",
    col_birthday: "Birthday",
    col_avg_ticket: "Average Ticket ($)",
    col_total_spent: "$ Spent",
    col_email: "E-mail",
    birthday_not_set: "Not informed",
    details_button: "Details",
    clients_now: "Clients now",
    selected_for_removal: "Selected for removal",
    remaining_after_removal: "Remaining clients after removal",
    delete_button_singular: "Delete {0} client",
    delete_button: "Delete {0} clients",
    confirm_phrase_placeholder_singular: "Delete {0} client permanently",
    confirm_phrase_placeholder_plural: "Delete {0} clients permanently",
    no_clients: "You don't have any registered clients yet",
    total_stats: {
        title: "Base Total",
        clients: "Clients",
        leads: "Leads",
        total: "Total (Clients + Leads)",
    },
    clients_by_branch: {
        title: "Clients by Branch",
        clients_in: "Clients in {0}",
    },
    deletion_info: {
        irreversible: "Deleting clients or leads from the base is an irreversible action.",
        will_delete: "Along with the clients we will delete:",
        all_sales: "All their sales",
        all_tasks: "All their tasks",
        all_messages: "All sent messages",
        all_records: "Any record linked to this client",
        permanent: "This deletion is permanent.",
        inconsistency: "Deleting part of your clients may cause data inconsistency",
        inconsistency_detail: ", from the moment you delete part of your clients, Kevi's reports may no longer reflect the same numbers as your ERP.",
    },
};
